var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "https://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.007 21.32h-4.002v-6.266c0-1.495-.027-3.417-2.08-3.417-2.085 0-2.404 1.628-2.404 3.309v6.374H10.52V8.435h3.842v1.76h.053c.535-1.013 1.841-2.08 3.79-2.08 4.054 0 4.803 2.668 4.803 6.137v7.068zm-15-12.885V21.32H4.004V8.435h4.005zm-2-6.405a2.322 2.322 0 1 1-.001 4.643 2.322 2.322 0 0 1 0-4.643zM25 0H1.993C.893 0 0 .871 0 1.946v23.105C0 26.127.893 27 1.993 27H25c1.103 0 2-.873 2-1.95V1.946C27 .871 26.103 0 25.001 0z"
})));
export default SvgLinkedin;